export const HandednessFields = {
  PITCHING: 'pitchingHandedness',
  BATTING: 'battingHandedness',
} as const;

export type HandednessFields = (typeof HandednessFields)[keyof typeof HandednessFields];
